<template>
  <section v-if="!this.$store.state.page.isMobile" style="height: 90vh; display: flex; flex-direction: column;">
    <div class="gameBox" v-if="url" style="flex: 1; display: flex;">
      <iframe scrolling="auto" frameborder="0"
              style="width: 100%; height: 100%;
          margin:0px 0px 0px 0px; z-index: 1; border: none;"
              allowFullScreen="true"
              :src="url">
      </iframe>
    </div>
  </section>
  <div class="mini-game" v-else style="height: 90vh; display: flex; flex-direction: column;">
    <div style="flex: 1; display: flex;">
      <iframe frameborder="0"
              style="width: 100%; height: 100%; overflow-y: auto;
              margin:0px 0px 0px 0px; z-index: 1; border: none;"
              allowFullScreen="true"
              webkitallowfullscreen="true"
              :src="url">
      </iframe>
    </div>
  </div>
</template>

<script>

export default {
  name: "SportIntegrationEuropean",
  components: {
  },
  data: function(){
    return {
      url: null,
      siteName: 'luna',
      pointColor: '#a97bf5',
    }
  },
  mounted() {
    this.initUrl();
  },
  methods: {
    initUrl: function(){
      let token = localStorage.getItem("authToken");
      const siteName = this.siteName;
      const pointColor = this.pointColor;
      let baseUrl = 'https://d3hn1xyam8hxou.cloudfront.net/betconstruct/special/';
      // let baseUrl = 'http://localhost:3000/betconstruct/european/';

      const params = [];
      if (token) {
        params.push(`token=${token}`);
      }
      if (siteName) {
        params.push(`siteName=${siteName}`);
      }
      if (pointColor) {
        params.push(`pointColor=${encodeURIComponent(pointColor)}`);
      }

      if (params.length > 0) {
        this.url = `${baseUrl}?${params.join('&')}`;
      } else {
        this.url = baseUrl;
      }
    }
  }
}
</script>

<style scoped>

</style>
